import React from "react";
import "./ContactPopup.css";

const ContactPopup = ({ message, onClose }) => {
  return (
    <div className="popup">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>
          X
        </button>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ContactPopup;
